import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

import { applyPictureSettings, applyShowSettings } from "./mock";

const root = ReactDOM.createRoot(document.getElementById("root"));
const render = () => root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

async function loadSettings() {
  const get = path => fetch(path, {cache: 'no-store', signal: AbortSignal.timeout(4000)}).then(response => {if (!response.ok) throw new Error('Settings unavailable');return response.json();});
  const [pictures, gallery] = await Promise.allSettled([get('/api/pictures.php'),get('/api/shows.php')]);
  if (pictures.status === 'fulfilled') applyPictureSettings(pictures.value);
  if (gallery.status === 'fulfilled') applyShowSettings(gallery.value);
}
loadSettings().finally(render);
